import { useState } from "react";
import { ErrorContent } from "../shared/error-content";
import { LoadingContent } from "../shared/loading-content";
import { DialogTitle } from "../shared/modal";
import { useAddToColorCollectionModalStore } from "../../../js/stores/add-to-color-collection-modal-store";
import { useEditColorCollectionsStore } from "../../../js/stores/edit-color-collections-store";
import {
  useAddToCollectionForm,
  useAddColor,
} from "../../../js/api/edit-collections/add-to-collection-form";
import { AddToColorCollectionForm } from "./add-to-color-collection-form";
import { SharedIcon } from "../shared/shared-icon";
import { toast } from "../../../js/components/toast";

export function AddToColorCollectionContent({ closeClickHandler }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const addToCollectionUrl = useAddToColorCollectionModalStore(
    (state) => state.addToCollectionUrl
  );
  const openNewCollectionFromModal = useEditColorCollectionsStore(
    (state) => state.openNewCollectionFromModal
  );
  const { data, isLoading, isError } = useAddToCollectionForm({
    addToCollectionUrl,
  });
  const [isFormSubmitting, setIsFormSubmitting] = useState(false);
  const [serverErrors, setServerErrors] = useState({});
  const addColorMutation = useAddColor();

  const showToastMessage = ({ isSuccess, message }) => {
    const toastTypeFunc = isSuccess ? toast.success : toast.error;
    toastTypeFunc(null, message);
  };

  const submitFormHandler = (body) => {
    if (data?.mainAction?.linkUrl && body) {
      setIsSubmitting(true);
      addColorMutation.mutate({
        url: data?.mainAction?.linkUrl,
        body,
        successHandler: (response) => {
          setIsSubmitting(false);
          closeClickHandler();
          showToastMessage(response);
          const collectionIdOnThePage = document.getElementById(
            "colour-collection-id"
          )?.value;
          if (
            collectionIdOnThePage &&
            body?.CollectionIds?.includes(collectionIdOnThePage + "") &&
            window?.location?.reload
          ) {
            window.location.reload();
          }
        },
        errorHandler: (data) => {
          setIsSubmitting(false);
          if (data?.response?.data?.errors) {
            setServerErrors({ ...data?.response?.data?.errors });
          }
        },
      });
    }
  };

  if (isLoading || isSubmitting) {
    return <LoadingContent />;
  }

  if (isError) {
    return <ErrorContent />;
  }

  return (
    <>
      <div className="add-to-collection-header">
        <div className="add-to-collection-container">
          <DialogTitle className="edit-color-collection-title">
            {data?.modalLabel}
          </DialogTitle>
        </div>
      </div>
      <div className="add-to-collection-main">
        <div className="add-to-collection-container">
          {data?.fields?.length > 0 && (
            <AddToColorCollectionForm
              submitHandler={submitFormHandler}
              data={data}
              isFormSubmitting={isFormSubmitting}
              setIsFormSubmitting={setIsFormSubmitting}
              serverErrors={serverErrors}
              setServerErrors={setServerErrors}
            />
          )}
        </div>
      </div>
      <div className="add-to-collection-footer">
        <div className="add-to-collection-container">
          <div className="add-to-collection-separator" />
          {data?.additionalAction && (
            <button
              className="add-to-collection-additional-action add-to-collection-additional-action--center"
              type="button"
              onClick={() => openNewCollectionFromModal(addToCollectionUrl)}
            >
              {data?.additionalAction?.linkLabel}
              <SharedIcon iconName="#sprite-plus" />
            </button>
          )}
          <div className="edit-color-collection-actions-wrapper">
            {data?.mainAction && (
              <button
                className="color-collection-action color-collection-action--main color-collection-action--order-main color-collection-action--grow"
                type="button"
                onClick={() => setIsFormSubmitting(true)}
              >
                {data?.mainAction?.linkLabel}
              </button>
            )}
            {data?.secondaryAction && (
              <button
                className="color-collection-action color-collection-action--secondary color-collection-action--order-secondary color-collection-action--grow"
                type="button"
                onClick={closeClickHandler}
              >
                {data?.secondaryAction?.linkLabel}
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
